import initialState from './initialState';
import produce from 'immer';

export default (state = initialState.rightPlayer, action) => {
	switch (action.type) {
		case 'RESET_WHOLE_STATE':
			return initialState.rightPlayer;
		//
		case 'SHOW_RIGHT_CARD':
			return produce(state, (draft) => {
				delete draft.cards[action.id - 1];
				draft.chosenCard = {
					show: action.show,
					suit: action.suit,
					card: action.card,
				};
			});

		case 'RESET_HAND':
			return produce(state, (draft) => {
				// draft.cards = [];
				draft.chosenCard.show = false;
			});

		case 'THROW_CARD':
			return produce(state, (draft) => {
				if (action.position === 'right') {
					draft.chosenCard = {
						show: action.show,
						suit: action.suit,
						card: action.card,
					};
				}
			});

		case 'SHOW_CLOCK':
			return produce(state, (draft) => {
				if (action.position === 'right' || action.value === false) {
					draft.clock = action.value;
				}
			});

		default:
			return state;
	}
};
